import LocalizedStrings from 'react-localization';
export default new LocalizedStrings({
    en: {
        // QR Verification constants
        qrPollingTimeoutMessage: 'QR verification timed out after 5 minutes',
        // Loading status messages
        loadingReadingFileInfo: 'Reading file information...',
        loadingReadingEncryptedData: 'Reading encrypted file data...',
        loadingAuthAndGps: 'Getting location and checking authentication...',
        loadingAuthenticationRequired: 'Authentication required...',
        loadingRequestingDecryption: 'Requesting decryption permission...',
        loadingQrVerificationRequired: 'QR verification required...',
        loadingQrVerifiedRetrying: 'QR code verified, retrying decryption...',
        loadingDecryptingFileData: 'Decrypting file data...',
        loadingReAuthenticating: 'Re-authenticating...',
        // Error messages
        errorNoAccounts: 'No accounts available. Please add an account first.',
        errorControllerNotAvailable: 'Controller not available for API calls',
        errorNoValidTokens: 'No valid tokens found, need to prompt for login',
        errorAccessCheckFailed: 'Access check failed:',
        errorAccessDenied: 'Access denied: None of your accounts have permission to decrypt this file. Please contact the file owner to grant you access.',
        errorInternalErrorAccountNotFound: 'Internal error: Could not find account for authorized user',
        errorNoValidTokenForAccount: 'has access to this file but no valid token. Please authenticate with this account first.',
        errorAuthenticationFailed: 'has access to this file but authentication failed. Please re-authenticate with this account.',
        errorInvalidQrData: 'Invalid QR data',
        errorQrDataMissing: 'QR verification required but no QR data provided',
        errorServerError: 'Server error:',
        errorNoServerSeed: 'No server seed available for decryption',
        errorAuthenticationRequiredAgain: 'Authentication required. Please log in again.',
        errorQrVerificationCancelledUnmounted: 'QR verification cancelled - component unmounted',
        errorAuthenticationCancelled: 'Authentication cancelled by user',
        errorQrVerificationTimeout: 'QR verification timed out after 5 minutes',
        errorInvalidQrDataGeneral: 'Invalid QR data',
        errorQrVerificationCancelledUser: 'QR verification cancelled by user',
        errorTokenExpired: 'Token expired',
        // Response code specific error messages
        responseErrorAccessDeniedGps: 'Access Denied - Invalid GPS location',
        responseErrorSunriseNotReached: 'Sunrise has not been reached\n\nThis Secure File can be opened after\n',
        responseErrorSunsetPassed: 'Sunset has passed\n\nThis Secure File cannot be opened after\n',
        responseErrorUnauthorizedUser: 'Unauthorized User - Access denied',
        responseErrorUnknownTime: 'unknown time'
    }
});
